<template>
  <!-- 出差申请 -->
  <div class="detail">
    <ax-panel title="出差信息">
      <van-cell title="申请人">
        <a class="link_a" :href="'tel:' + data.header.emplid_phone">
          {{ data.header.emplid_description }}
        </a>
      </van-cell>
      <!-- <van-cell title="始发地" :value="data.header.qh_start_place"></van-cell>
      <van-cell title="目的地" :value="data.header.qh_end_place"></van-cell> -->
      <van-cell title="出差类型">
        {{
          data.header.qh_international === "Y"
            ? "国内"
            : data.header.qh_international === "N"
            ? "国际"
            : ""
        }}
      </van-cell>
      <!-- <van-cell title="开始日期" :value="data.header.bgn_dt"></van-cell>
      <van-cell title="结束日期" :value="data.header.end_dt"></van-cell> -->
      <van-cell title="出差总时长">
        {{ data.header.qh_total_days }}天
      </van-cell>
      <van-cell title="出差说明" :value="data.header.comments">
        <div>
          <p v-for="i in data.header.comments.split('\n')" style="line-height:28px">
            {{i}}
          </p>
        </div>
      </van-cell>
      <van-cell title="附件" v-if="data.qh_abs_005_atta.length">
        <ax-down
          v-for="(fileItem, index) in data.qh_abs_005_atta"
          type="ssc"
          :data="{
            fileName: fileItem.filename,
          }"
          :key="index"
        >
          <router-link
            slot="fileName"
            class="link_a"
            :to="{
              name: 'fileImg',
              query: {
                ...$route.query,
                attachsysfilename: fileItem.attachsysfilename, // 附件唯一名称
                emplid: data.header.emplid, // 员工编号
                action_dt_ss: data.header.action_dt_ss, // 提交时间
                effseq: data.header.effseq, // 生效序号
                path: $route.query.pageId,
              },
            }"
            >{{ fileItem.filename }}</router-link
          >
          <a class="item_content_val link_a" slot="right">
            <van-icon name="arrow" />
          </a>
        </ax-down>
      </van-cell>
    </ax-panel>
    <!-- 新增出差列表 -->
    <div class="navtab">
      <ul>
        <li
          v-for="(itme, index) in triptab"
          :class="{ currend: currend == index }"
          @click="tabsTrip(index)"
        >
          {{ itme.text }}{{ index + 1 }}
        </li>
      </ul>
    </div>
    <ax-trip :tripData = 'tripData'/>
    <!-- 列表 -->
    <ax-trip-list :dataarr = "dataarr" :title="'出差行程明细信息'" />
  </div>
</template>

<script>
import AxTrip from "../../components/common/AxTrip.vue";
import AxTripList from "../../components/common/AxTripList.vue";

export default {
  props: ["data"],
  components: {
    "ax-trip": AxTrip,
    "ax-trip-list": AxTripList,
  },
  mounted() {},
  data() {
    return {
      currend: 0, // 行程tab
      triptab: [],
      tripData: {
        bgn_dt: '',
        end_dt: '',
        qh_start_place: '',
        qh_end_place: '',
        qh_total_days: '0',
        seqnbr: '0'
      },
      dataarr: []
    };
  },
  watch: {
    data() {
      if(this.data.header.qh_gp_is_change === 'Y'){
        this.$setIosTitle('出差变更申请');
      }
      this.initTripTab(this.data.qh_abs_005_hd01.length);
      this.tabsTrip(0)
    },
  },
  methods: {
    // 初始化形成tab
    initTripTab(len) {
      for (let t = 0; t < len; t++) {
        this.triptab.push({ text: "行程" });
      }
    },
    // 切换形成tab
    tabsTrip(idx) {
      this.currend = idx
      this.tripData = this.data.qh_abs_005_hd01[idx]
      this.dataarr = this.sort(this.data.qh_abs_005_hd01[idx].qh_abs_005_dtl)
    },
    // 日期排序
    sort(arr) {
      arr.sort(function (a, b) {
        let obj1 = a['dur']
        let obj2 = b['dur']
        const val1 = Math.floor(new Date(obj1).getTime() / 1000)
        const val2 = Math.floor(new Date(obj2).getTime() / 1000)
        return val1 - val2
      });
      return arr
    },
  },
};
</script>

<style lang="scss" scoped>
.van-cell .van-cell__value {
  text-align: right;
  padding-right: 0.6rem;
}

.navtab {
  margin-top: -8px;
  height: 35px;
  line-height: 35px;
  display: flex;
  background: #fff;
  padding: 0 16px;
  font-size: 14px;
  font-weight: 500;
  box-sizing: border-box;
  border-radius: 0 0 15px 15px;
}

.navtab ul {
  flex-grow: 1;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: scroll;
}
.navtab .addxc{
  color: #3873FA;
}
.navtab .addxc i {
  color: #3873FA;
  font-size: 14px;
  position: relative;
  right: 1px;
  top: 0px;
  /* font-weight: 600 */
}
.navtab .addxc .setyanse {
  color: #1B2532;
  font-size: 17px;
  position: relative;
  right: 5px;
  top: 0px;
  /* font-weight: 600 */
}

.navtab ul li {
  /* margin-left: 3px; */
  margin-right:24px;
  flex-shrink: 0;
  line-height: 30px;
  font-weight: 400;
  color: #637387;
}

.navtab ul li::after {
  content: ' ';
  display: block;
  width: 100%;
  height: 3px;
  border-radius: 1px;
  background: #fff;
  position: relative;
  top: 2px;
}

.navtab .currend::after {
  content: ' ';
  display: block;
  width: 100%;
  height: 3px;
  border-radius: 4px;
  background: #3873FA;
  top: 2px;
}
.navtab .currend {
  color: #3873FA;
  line-height: 30px;
  font-weight: 500;
}
</style>
